export default `
<style>
.footer-social-title {
  font-size: var(--b-font-size-l);
  margin-bottom: var(--b-spacing-m);
  text-transform: uppercase;
  color: var(--footer_txt_2);
  font-weight: var(--b-font-weight-bold);
}
.footer-social-list {
  margin: 0;  
  padding: 0;  
  list-style-type: none;
}
.footer-social-list {
  display: flex; 
  gap: 15px;
}
.footer-social-list img {
  opacity: 0.7;
  transition: opacity .4s;
}
.footer-social-list img:hover {
  opacity: 1;
}
@media (max-width: 1023px) {
  .footer-social {
    margin-bottom: var(--b-spacing-ms);
    padding-left: var(--b-spacing-ms);
    width: 100vw;
  }
}
</style>
<div class="footer-social">
    <div class="footer-social-title">Pratite nas</div>
    <ul class="footer-social-list">
        <li>
            <a href="https://www.facebook.com/favbet.hr" target="_blank" rel="noreferrer"> 
                <img src="https://www.favbet.hr/static/media/payment/logos/facebook.svg" alt="Facebook Favbet Hrvatska" />
            </a>
        </li>
        <li>
            <a href="https://www.youtube.com/channel/UCHu190NXJadx33NsWub3uqQ" target="_blank" rel="noreferrer">
                <img src="https://www.favbet.hr/static/media/payment/logos/youtube.svg" alt="Youtube Favbet Hrvatska" />
            </a>
        </li>
        <li>
            <a href="https://www.instagram.com/favbet_croatia/" target="_blank" rel="noreferrer">
                <img src="https://www.favbet.hr/static/media/payment/logos/instagram.svg" alt="Instagram Favbet Hrvatska" />
            </a>
        </li>
    </ul>
</div>`;
